<template>
  <div class="brand-detail-v2">
    <div class="container">
      <div v-if="loading_brand" class="popular-review">
        <GFMP :styles="{ minHeight: '1140px', marginBottom: '5px' }" />
      </div>
      <div v-else class="brand-detail">
        <div class="brand-detail__images">
          <img
            v-if="brand && brand.logo && brand.name"
            class="img-responsive img-block"
            :src="mainImage(brand.logo)"
            :alt="brand.name"
            @error="brandImageErrorHandler($event)"
          />
          <img v-else src="/assets/img/default_img_brand.svg" class="img-responsive img-block" alt="no image" />
        </div>
        <div class="brand-detail__desc">
          <div class="container-title">
            <p class="title">{{ brand.name.toUpperCase() }}</p>
            <div class="origin">
              <template v-if="brand.country">
                <img :src="brand.flag" alt="" class="logo-country" />
                <span class="name-country">{{ brand.country }}</span>
                <span class="separator"></span>
              </template>
              <span class="total-products">{{ brand.total_products }} products</span>
            </div>
          </div>
          <div class="container-description">
            <div v-if="brandDesc" class="brand-details__body">
              <template v-if="String(brandDesc).length > 282">
                <div v-if="seeMoreOpen">
                  <p class="desc">
                    {{ brandDesc }}
                    <span class="see-more see-less" @click.prevent="toggleSeeMore"> See less </span>
                  </p>
                </div>
                <div v-else>
                  <p class="desc">
                    {{ brandDesc | trimRecentReviewContent }}
                    <span class="see-more" @click.prevent="toggleSeeMore">See more</span>
                  </p>
                </div>
              </template>
              <template v-else>
                <!-- eslint-disable-next-line vue/no-v-html-->
                <p v-html="brandDesc"></p>
              </template>
            </div>
          </div>
        </div>
      </div>
      <article v-if="loading_review || (popular_review && popular_review.length > 4)" class="popular-review">
        <header>
          <h1>Popular by Review</h1>
        </header>
        <section>
          <carousel
            :per-page="isDesktop ? 3 : 1"
            :navigation-enabled="true"
            navigation-next-label
            navigation-prev-label
            pagination-color="#E5E5E5"
            pagination-active-color="#F384A7"
            class="recent-review-carousel"
          >
            <slide
              v-for="(review, i) in loading_review ? 3 * 4 : popular_review"
              :key="`popular-review-${i}`"
              class="slides"
            >
              <div v-if="loading_review" style="padding: 4px">
                <CardPopularReviewLoader />
              </div>
              <CardPopularReview v-else :review-data="review" />
            </slide>
          </carousel>
        </section>
      </article>
      <main v-if="isDesktop" class="brand-detail-product-desktop">
        <section class="product-filter">
          <ProductFilter :show-title="false" @sectionClick="handleSectionClick"></ProductFilter>
        </section>
        <section class="product-grid">
          <div v-if="isShowFilterList" class="container-list-filter">
            <div class="list-filter">
              <template v-for="(item, i) in Object.keys($route.query)">
                <div v-if="item === 'category'" :key="i" class="list">
                  <template v-for="(categoryItem, _i) in listCategoryItems(queryString[item])">
                    <span
                      v-if="categoryItem"
                      :key="_i"
                      class="item-list"
                      @click.prevent="onDeleteItem(item, categoryItem._id)"
                    >
                      {{ categoryItem.name }}
                      <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14" />
                    </span>
                  </template>
                </div>
                <div v-if="item === 'brands'" :key="i" class="list">
                  <template v-for="(brandItem, _i) in listSelectedBrand(queryString[item])">
                    <span
                      v-if="brandItem"
                      :key="_i"
                      class="item-list"
                      @click.prevent="onDeleteItem(item, brandItem._id)"
                      >{{ brandItem.name }} <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'origins'" :key="i" class="list">
                  <template v-for="(origin, _i) in listSelectedBrandOrigin(queryString[item])">
                    <span v-if="origin" :key="_i" class="item-list" @click.prevent="onDeleteItem(item, origin._id)"
                      >{{ origin.name }} <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'available_for'" :key="i" class="list">
                  <template v-for="(available, _i) in listAvailable(queryString[item])">
                    <span v-if="available" :key="_i" class="item-list" @click.prevent="onDeleteItem(item, available)"
                      >{{ available | changeAvailableName }}
                      <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'rating' && queryString[item]" :key="i" class="list">
                  <span class="item-list" @click.prevent="onDeleteItem(item, queryString[item])">
                    <i class="icon_star"></i> {{ parseFloat(queryString[item]).toFixed(1) }}
                    <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14" />
                  </span>
                </div>
              </template>
            </div>
            <div v-if="showClearAllButton" class="list-reset">
              <span @click.prevent="reset"> Clear all </span>
            </div>
          </div>
          <ProductGrid
            :products="products"
            :title="title"
            :loading="loading"
            :lists_count="total_products"
            @infiniteHandler="infiniteHandler"
          />
        </section>
      </main>
      <main v-else class="brand-detail-product-mobile">
        <section class="product-grid">
          <ProductGrid
            :products="products"
            :title="title"
            :loading="loading"
            :lists_count="total_products"
            @infiniteHandler="infiniteHandler"
          />
          <ModalFilterV2
            v-if="showModalFilterV2"
            :list_brands="$store.state.$_Review.brandList"
            :list_country="$store.state.$_Review.countryList"
            :categories="$store.state.$_Review.categories"
            :options="{ available: true, brands: false, rating: true, category: false }"
          />
        </section>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: 'brand-details',
  components: {
    ProductGrid: () => import('@/components/v2/product-grid'),
    ProductFilter: () => import('@/components/v2/product-filter'),
    CardPopularReview: () => import('@/components/v2/snippets/card-popular-review'),
    ModalFilterV2: () => import('@/components/global/modal/modal-filter-v2'),
    CardPopularReviewLoader: () => import('@/components/global/loader/card-popular-review-loader'),
  },
  data() {
    return {
      title: 'All Products',
      infinite: false,
      seeMoreOpen: false,
      clickedSection: null,
    };
  },
  computed: {
    showClearAllButton() {
      return (
        this.clickedSection === 'filter' ||
        this.$route.query.category ||
        this.$route.query.brands ||
        this.$route.query.origins ||
        this.$route.query.rating ||
        this.$route.query.available_for
      );
    },
    brandId() {
      return this.$route.params.brand_id;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    products() {
      return this.$store.state.$_Brand.product;
    },
    loading() {
      return this.$store.state.$_Brand.loading;
    },
    loading_brand() {
      return this.$store.state.$_Brand.brand.loading;
    },
    loading_review() {
      return this.$store.state.$_Brand.popular_review.loading;
    },
    brand() {
      return this.$store.state.$_Brand.brand.data;
    },
    showModalFilterV2() {
      return this.$store.state.modal.isModalShow.filterV2;
    },
    brandDesc() {
      return this.brand.description
        ? this.$options.filters.stripHTML(this.brand.description)
        : this.$options.filters.stripHTML(this.brand.short_description);
    },
    total_products() {
      return this.$store.state.$_Brand.total_product;
    },
    popular_review() {
      return this.$store.state.$_Brand.popular_review.data;
    },
    isShowFilterList() {
      return Object.keys(this.$route.query).filter((q) => q !== 'sort').length && this.isDesktop;
    },
  },
  watch: {
    'queryString.category'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getBrandDetail();
      }
    },
    'queryString.available_for'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getBrandDetail();
      }
    },
    'queryString.rating'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getBrandDetail();
      }
    },
    '$route.query'(to, from) {
      if (to != from) {
        this.$store.dispatch('$_Review/serialize', this.$route.query);
        this.getBrandDetail();
      }
    },
    '$route.path'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.reset();
      }
    },
    brand(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.commit('setPageInfo', {
          title: newVal.name,
        });
      }
    },
    queryString: {
      deep: true,
      handler(newVal) {
        for (const key in newVal) {
          if (key !== 'sort' && key !== 'limit' && key !== 'skip') {
            if (newVal[key] === '') {
              this.handleSectionClick(null);
            }
          }
        }
      },
    },
  },
  mounted() {
    this.$store.commit('$_Brand/SET_DATA_BRAND', '');
    this.$store.dispatch('$_Review/serialize', this.$route.query);
    this.getBrandDetail();
  },
  methods: {
    async getBrandDetail() {
      this.$store.dispatch('$_Brand/getBrands', this.$route.params.brand_id);
    },
    getProductsCount() {
      this.$store.dispatch('$_Brand/getProductsTotal', this.$route.params.brand_id);
    },
    brandImageErrorHandler(e) {
      e.target.src = '/assets/img/default_img_brand.svg';
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=120',
        image: src,
      });
    },
    checkSameQueryParams(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }

      return true;
    },
    apply() {
      let query = Object.assign({}, this.$route.query);

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: 0,
      });

      if (this.queryString.category) {
        query = Object.assign(query, { category: this.queryString.category });
      } else {
        if (query.category) {
          delete query.category;
        }
      }

      if (this.queryString.available_for) {
        query = Object.assign(query, { available_for: this.queryString.available_for });
      } else {
        if (query.available_for) {
          delete query.available_for;
        }
      }

      if (this.queryString.rating) {
        query = Object.assign(query, { rating: this.queryString.rating });
      } else {
        if (query.rating) {
          delete query.rating;
        }
      }

      if (query.page) {
        query.page = 1;
      }

      if (!this.checkSameQueryParams(this.$route.query, query)) {
        this.$router.push({ query: query });
      }
    },
    infiniteHandler($state) {
      let skip = Number(this.queryString.skip);
      const limit = Number(this.queryString.limit);
      const newSkip = (skip += limit);
      const brandId = this.$route.params.brand_id;

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: newSkip,
      });

      this.$store
        .dispatch('$_Brand/loadMoreProducts', brandId)
        .then((response) => {
          if (response.data.data && response.data.data.length) {
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((err) => {
          $state.complete();
        });
    },
    reset() {
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });
      this.$router.push(`/brand/${this.brandId}/${this.brand.name}`);
    },
    toggleSeeMore() {
      this.seeMoreOpen = !this.seeMoreOpen;
    },
    listSelectedBrand(item) {
      const filterBrands = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Review'].brandList.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Review'].brandList
            .filter((xx) => xx['_id'] === x)
            .map((brand) => ({ _id: brand._id, name: brand.name }));
          if (data.length) {
            filterBrands.push(data[0]);
          }
        });
      }
      return filterBrands;
    },
    listSelectedBrandOrigin(item) {
      const filterOrigins = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Review'].countryList.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Review'].countryList
            .filter((xx) => xx['country_tag_id'].toString() === x)
            .map((origin) => ({ _id: origin.country_tag_id, name: origin.country }));
          if (data.length) {
            filterOrigins.push(data[0]);
          }
        });
      }
      return filterOrigins;
    },
    listAvailable(item) {
      const arrayItem = item.split(',');
      return arrayItem;
    },
    listCategoryItems(item) {
      const data = this.$store.state['$_Brand'].categories;
      const temp = [];
      for (const i in data) {
        temp.push({
          id_category: data[i]._id,
          link_rewrite: data[i].link_rewrite,
          name: data[i].name,
          id_parent: '',
        });
        if (data[i].children != undefined && data[i].children.length) {
          const child = data[i].children;
          for (const j in child) {
            temp.push({
              id_category: child[j]._id,
              link_rewrite: child[j].link_rewrite,
              name: child[j].name,
              id_parent: child[j].id_parent,
            });
            if (child[j].children != undefined && child[j].children.length) {
              const sub = child[j].children;
              for (const k in sub) {
                temp.push({
                  id_category: sub[k]._id,
                  link_rewrite: sub[k].link_rewrite,
                  name: sub[k].name,
                  id_parent: sub[k].id_parent,
                });
              }
            }
          }
        }
      }
      return temp.filter((xx) => xx['id_category'] === item);
    },
    onDeleteItem(item, value) {
      const queryValue = JSON.parse(JSON.stringify(this.queryString[item]));
      if (queryValue) {
        if (item === 'brands') {
          const brands = queryValue.split(',');
          const index = brands.indexOf(value);
          brands.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'brands',
            value: brands.join(','),
          });
        }
        if (item === 'origins') {
          const origins = queryValue.split(',');
          const index = origins.indexOf(value);
          origins.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'origins',
            value: origins.join(','),
          });
        }
        if (item === 'category') {
          const category = queryValue.split(',');
          const index = category.indexOf(value);
          category.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'category',
            value: category.join(','),
          });
        }
        if (item === 'available_for') {
          const available = queryValue.split(',');
          const index = available.indexOf(value);
          available.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'available_for',
            value: available.join(','),
          });
        }
        if (item === 'rating') {
          const rating = queryValue.split(',');
          const index = rating.indexOf(value);
          rating.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'rating',
            value: rating.join(','),
          });
        }
      }
    },
    handleSectionClick(section) {
      this.clickedSection = section;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';
@mixin sectionHeader() {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    margin: 0;
    font-family: $lato-bold;
    font-size: 16px;
    line-height: 22px;
    color: #231f20;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
}
@mixin carousel() {
  &::v-deep {
    .VueCarousel-wrapper {
      padding-bottom: 10px;
    }
    .VueCarousel-pagination {
      bottom: 0;
      .VueCarousel-dot-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        button.VueCarousel-dot {
          padding: 0 !important;
          height: 6px !important;
          width: 6px !important;
          &--active {
            height: 10px !important;
            width: 10px !important;
          }
        }
      }
    }
    .VueCarousel-navigation-prev {
      left: 15px;
    }
    .VueCarousel-navigation-next {
      right: 15px;
    }
  }
}

.popular-review {
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 20px;
  @media (max-width: 991px) {
    margin-bottom: 0;
    padding: 16px 10px;
  }
  header {
    @include sectionHeader();
  }
  .recent-review-carousel {
    @include carousel();
    &::v-deep .VueCarousel-inner {
      margin-right: -8px;
      .VueCarousel-slide {
        position: relative;
        @media (max-width: 768px) {
          left: -5px;
        }
      }
    }
    &::v-deep {
      .VueCarousel-wrapper {
        padding-bottom: 32px;
      }
    }
  }
}
.see-more {
  color: #dc0034;
  font: 12px/15px 'lato-bold', sans-serif;
  padding-right: 15px;
  display: inline-block;
}
.brand-detail-v2 {
  padding-top: 24px;
  .brand-detail {
    display: flex;
    width: 100%;
    padding: 36px 32px 32px 32px;
    align-items: flex-start;
    gap: 24px;
    background-image: url('/assets/img/brand-detail-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 4px;
    margin-bottom: 20px;
    &__images {
      display: flex;
      width: 120px;
      height: 120px;
      align-items: flex-start;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 4px;
      border: 4px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.15);
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #fff;
      }
    }
    &__desc {
      margin-left: 24px;
      .container-title {
        display: flex;
        flex-direction: column;
        .title {
          color: #231f20;
          font-family: 'lato-bold', sans-serif;
          font-size: 20px;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          margin-bottom: 0;
        }
        .separator {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background: #231f20;
          margin: 0 7px;
          display: inline-block;
          position: relative;
          top: -3px;
        }
        .origin {
          margin-bottom: 12px;
          .logo-country {
            width: 23px;
            height: 16px;
            background-color: transparent;
            border-radius: 2px;
            margin-right: 8px;
          }
          .name-country {
            color: #231f20;
            font-family: 'lato-regular', sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 18px;
            text-transform: capitalize;
          }
          .total-products {
            color: #716a68;
            font-family: 'lato-regular', sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 18px;
          }
        }
      }
      .container-description {
        p {
          color: #716a68;
          font-family: 'lato-regular', sans-serif;
          font-size: 12px;
          font-style: normal;
          line-height: 18px;
        }
      }
    }
  }
  .brand-detail-product-desktop {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    background-color: $white;
    padding: 30px 0 66px 0;
    .product-grid {
      flex: 1 0 auto;
      .container-list-filter {
        display: flex;
        position: relative;
        width: 100%;
        max-width: 900px;
        justify-content: space-between;
        overflow: hidden;
        .list-filter {
          display: flex;
          flex-direction: row;
          margin: 10px 0 15px;
          transition: transform 0.3s ease-in-out;
          overflow-x: auto;
          width: calc(100% - 100px);
          -ms-overflow-style: none;
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }
          .list {
            display: flex;
            flex-direction: row;
            .item-list {
              display: flex;
              width: max-content;
              height: 28px;
              padding: 0px 8px;
              justify-content: center;
              align-items: center;
              gap: 8px;
              border: 1px solid #e5e5e5;
              background-color: white;
              border-radius: 4px;
              color: #231f20;
              font-family: 'lato-regular', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 22px;
              margin: 0 5px 0 0;
              cursor: pointer;
            }
          }
        }
        .list-reset {
          width: auto;
          height: 30px;
          padding: 0px 8px;
          border: none;
          color: #dc0034;
          font: 14px/28px 'lato-bold', sans-serif;
          letter-spacing: normal;
          cursor: pointer;
          margin: 10px 0 15px;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
    }
    ::v-deep .icon_star {
      color: #f384a7;
      height: 15px;
    }
  }
}
@media (max-width: 991px) {
  .brand-detail-v2 {
    padding: 0;
    .container {
      padding: 0;
    }
    .brand-detail {
      flex-direction: column;
      align-items: center;
      background-image: url('/assets/img/brand-detail-mobile.png');
      background-repeat: no-repeat;
      background-size: 100% 56px;
      padding: 14px 16px;
      &__images {
        width: 74px;
        height: 74px;
      }
      &__desc {
        margin: 0 auto;
        .container-title {
          text-align: center;
          margin-top: -15px;
          .title {
            font-size: 14px;
          }
        }
      }
    }
    .brand-detail-product-mobile {
      padding: 14px 10px;
    }
  }
}
</style>
